import React from 'react';
import { Link } from 'react-router-dom'

import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import dataRoadMap2 from '../assets/fake-data/data-roadmap2';

import mission from '../assets/images/pages/our-mission.png'
import vission from '../assets/images/pages/our-vission.png'
import Action from '../components/layouts/Action';
import RoadMap2 from '../components/layouts/RoadMap2';
import img from '../assets/images/items/group-ntf-03.png'

const OurMission = () => {
    return (
        <div className='mission'>
            <Header />
            <section className="tf-section page-title">
                <div className="container">
                    <div className="col-md-12">
                        <div className="page-title__body rm">
                            <div className="block-text pt-12">
                                <h2 className="sub-title mb-20">My History Studio</h2>
                                <p className="fs-24 mb-33" >Your life is a story worth preserving. <br />  I help you get it done. </p>
                            </div>
                            <img className="s2" src={img} alt="Life story preservation creating archival memory albums and videos from personal history memorabilia" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="tf-section visions">
                <div className="container">
                    <div className="row reverse">
                        <div className="col-xl-7 col-md-12">
                            <div className="group-image" data-aos="flip-left"
                            data-aos-easing="ease-out-cubic"
                            data-aos-duration="2000">
                                <img src={mission} alt="Monteno" />
                            </div>
                        </div>
                        <div className="col-xl-5 col-md-12">
                            <div className="block-text pt-12">
                                <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">Start preserving history</h5>
                                <h3 className="title mb-37" data-aos="fade-up" data-aos-duration="1000">Collect, Curate, Create </h3>
                                <p className="fs-18 mb-41" data-aos="fade-up" data-aos-duration="1000">Collect: I gather your photos, documents, videos, and other memories, digitizing them with care. <br />Curate: I work with you to organize your memories into a cohesive narrative, complete with anecdotes and insights. <br />Create: We produce a beautifully bound book and digital archive that you can share for generations.</p>
                                <Link to="/my-history-studio/process" className="btn-action style-2"  data-aos="fade-up" data-aos-duration="1200">Explore the Process</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="tf-section missions">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-5 col-md-12">
                            <div className="block-text pt-12">
                                <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">Archival Albums</h5>
                                <h3 className="title mb-37" data-aos="fade-up" data-aos-duration="1000">Sharing for the generations </h3>
                                <p className="fs-18 mb-29" data-aos="fade-up" data-aos-duration="1000">
                                    I belive that every individual has a story and I take pride in ensuring we can tell it. </p>
                                <ul data-aos="fade-up" data-aos-duration="1000">
                                    <li><i className="fa fa-check"></i><p className="fs-18">The overall process is both affiriming and positive. </p></li>
                                    <li><i className="fa fa-check"></i><p className="fs-18">I use nationally aligned practices and standards set out by the Library of Congress </p></li>
                                    <li><i className="fa fa-check"></i><p className="fs-18">I apply the gold standard to every preservation project. </p></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-7 col-md-12">
                            <div className="group-image" data-aos="flip-right"
                            data-aos-easing="ease-out-cubic"
                            data-aos-duration="2000">
                                <img src={vission} alt="Monteno" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <RoadMap2 data={dataRoadMap2} />

            <Action />
            <Footer />
        </div>
    );
}

export default OurMission;